module.exports = __webpack_public_path__ + "static/media/cb_3.9781cf03.svg";